import ChartScoutRoute from './ChartScoutRoute'
import * as d3 from 'd3'
import { D3Module, ModuleDataset, ModuleEvent, Size } from '@bpchart/types'
import Nodes, { NodeDatum } from './Nodes'
import Edges, { EdgeDatum } from './Edges'
// import { getLabelInfo, parseRoutesData } from './utils'
import {
  PADDING_TOP,
  PADDING_LEFT,
  LINE_COLUMN_WIDTH,
  LINE_ROW_HEIGHT,
  LINE_TITLE_HEIGHT,
  EDGE_COUNT_TAG_LEFT,
  EDGE_CURVE,
  EDGE_SIDE_Y_OFFSET,
  NODE_WIDTH_DEFAULT,
  NODE_HEIGHT_MIN,
  NODE_TEXT_LEFT,
  NODE_TEXT_SIZE,
  NODE_TEXT_WIDTH_DEFAULT,
  SIDE_STEP } from './const'
import {
  // ChartSize,
  RoutesDataUp,
  // FilterConfig,
  ChartScoutRouteLinesFilterConfig,
  ChartScoutRouteLinesParams,
  SourceEdge,
  SourceNode,
  ChartScoutRouteLinesDataset,
  // ChartScoutRouteLinesUpdateConfig,
  LineRoute, 
  RoutesDataDown} from './types'
// import { ChartDirectedTreeSourceEdge } from '../chartDirected/ChartDirectedTree/ChartDirectedTree'

export interface LinesNodeDatum extends NodeDatum {
  index: number; // 陣列中的index
  id: string; // ${_routeIndex}_${uniID}
  uniID: string; // 同id
  label: string;
  labels: string[]; // 換行文字存成陣列
  nodeType: string;
  x: number;
  y: number;
  width: number;
  height: number;
  hasTop: boolean;
  isTopExpanded: boolean;
  tags: Array<string>;
  sourceData: SourceNode; // 原始資料
  // extends
  // _routesDataUp: Array<RoutesData>; // 所有路徑（排序過的）
  _sourceId: string; // uniID
  _routeIndex: number;
  _nodeIndex: number;
}

export interface LinesEdgeDatum extends EdgeDatum {
  id: string; // ${_routeIndex}_${startNodeId}->${endNodeId}
  startNodeId: string;
  endNodeId: string;
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  startCount: number; // 流出點顯示線條數量
  startCountX: number;
  startCountY: number;
  endCount: number; // 流入點顯示線條數量
  endCountX: number;
  endCountY: number;
  label: string;
  labelX: number;
  labelY: number;
  labelDotShow: boolean; // 顯示圓點
  labelTextAnchor: 'start' | 'middle' | 'end'; // label標籤的 text-anchor 對齊方式
  labelDominantBaseline: 'auto' | 'central' | 'hanging'; // label標籤的 dominant-baseline 對齊方式
  pathD: string;
  // sourceData: SourceEdge; // 原始資料
  value: number;
  // extends
  _sourceId: string; // ${startNodeId}->${endNodeId}
  _routeIndex: number;
  _startNodeIndex: number;
  _endNodeIndex: number;
  // _labelX: number;
  // _labelY: number;
  // _pathD: string; // path線條的 d屬性
  // _startCount: number; // 流出點顯示線條數量
  // _endCount: number; // 流入點顯示線條數量
}

const defaultStockMin = 0
const defaultStockExceptZero = false
const defaultSort: {
  'routes-of-stock-detail-single-value': -1 | 1
} = {
  'routes-of-stock-detail-single-value': -1
}

export default class ChartScoutRouteLines extends ChartScoutRoute implements
D3Module<ChartScoutRouteLinesParams>,
ModuleDataset<ChartScoutRouteLinesDataset, ChartScoutRouteLinesFilterConfig> {
  public selection: d3.Selection<any, any, any, any>
  public params: ChartScoutRouteLinesParams = {
    nodeTypeConfig: {},
    styleConfig: {},
    nodeTagConfig: {},
    titleContent: () => ''
  }
  declare public dataset: ChartScoutRouteLinesDataset

  protected filterConfig: ChartScoutRouteLinesFilterConfig = {
    stockMin: defaultStockMin,
    stockExceptZero: defaultStockExceptZero,
    sort: defaultSort
  }

  // private NodesDataMap: Map<string, LinesNodeData> | undefined
  private nodesData: Array<LinesNodeDatum> | undefined
  private edgesData: Array<LinesEdgeDatum> | undefined
  private routesOrigin: Array<LineRoute> = []
  private routes: Array<LineRoute> = []
  // private routesG: d3.Selection<SVGGElement, Routes, any, any>
  private containerColumnCount: number = 0 // 容器的欄數量
  // private eventTransform: { k:number; x:number; y:number } | undefined
  private sourceNodes: Array<SourceNode> = []
  private targetId: string | undefined
  // private routes: Array<RoutesData> = []
  private titleTextG: d3.Selection<SVGGElement, any, any, any> | undefined
  private titleText: d3.Selection<SVGTextElement, LineRoute, any, any> | undefined
  // private updateConfig: ChartScoutRouteLinesUpdateConfig | undefined

  constructor (el: d3.Selection<any, any, any, any>, params: ChartScoutRouteLinesParams) {
    super(el, params)
    this.selection = el
    // this.setParams(params)

    this.nodes = new Nodes(this.nodesG, {
      ...params,
      expand: false
    })
    this.edges = new Edges(this.edgesG, {
      
    })

    const { width, height } = this.getContainerSize()
    this.width = width
    this.height = height
    // 場景的欄數量
    this.containerColumnCount = this.getContainerColumnCount(this.width)

    this.titleTextG = this.svgGroup.append('g')

    // this.initZoom()
  }

  setDataset (dataset: ChartScoutRouteLinesDataset) {
    this.dataset = dataset
    this.sourceNodes = dataset.nodes
    this.targetId = dataset.targetId
    if (dataset.sort && dataset.sort['routes-of-stock-detail-single-value'] != undefined) {
      this.filterConfig.sort!['routes-of-stock-detail-single-value'] = dataset.sort['routes-of-stock-detail-single-value']
    }

    // 必須設定 targetId 才開始計算路徑及繪圖
    // if (this.targetId) {
      // 回復預設 zoom
      this.transformZoom({
        x: 0,
        y: 0,
        k: 1
      })
      if (this.dataset.mainRelatedToRoot === 'up') {
        this.routesOrigin = this.createRoutesData(this.sourceNodes, this.targetId)
      } else if (this.dataset.mainRelatedToRoot === 'down') {
        this.routesOrigin = this.createRoutesDownData(this.sourceNodes, this.targetId)
        // console.log('this.routesOrigin', this.routesOrigin)
      } else {
        return
      }
      
      this.routes = Object.assign(this.routesOrigin)
      // 如有設定 stockMin才進行篩選
      this.filterConfig.stockMin = dataset.stockMin != undefined ? dataset.stockMin : this.filterConfig.stockMin
      this.filterConfig.stockExceptZero = dataset.stockExceptZero != undefined ? dataset.stockExceptZero : this.filterConfig.stockExceptZero
      if (this.filterConfig.stockMin! >= 0 || this.filterConfig.stockExceptZero == true) {
        this.routes = this.filterRoutes(this.routes, this.filterConfig, this.dataset.mainRelatedToRoot)
      }
      this.routes = this.updateRoutesDataPosition(this.routes, this.containerColumnCount)
      // console.log('this.routes', this.routes)
      // this.render()
    // }
  }

  render () {
    this.nodesData = this.routes.map(d => d.nodesData).flat()
    this.edgesData = this.routes.map(d => d.edgesData).flat()

    this.nodes!.setData(this.nodesData!)
    this.edges!.setData(this.edgesData!)

    // console.log('this.nodesData', this.nodesData)
    // console.log('this.edgesData', this.edgesData)

    this.nodes!.render()
    this.edges!.render()

    const titleTextUpdate = this.titleTextG!
      .selectAll<SVGTextElement, LineRoute>('text')
      .data(this.routes, d => d.index)
    const titleTextEnter = titleTextUpdate.enter()
      .append<SVGTextElement>('text')
      .text(d => {
        return d.title
      })
      .attr('font-size', 14)
      .style('cursor', 'default')
    titleTextEnter
      .attr('x', d => d.x)
      .attr('y', 0)
      .transition()
      .attr('x', d => d.x)
      .attr('y', d => d.y)
    titleTextUpdate
      .text(d => {
        return d.title
      })
      .transition()
      .attr('x', d => d.x)
      .attr('y', d => d.y)
    this.titleText = titleTextUpdate.merge(titleTextEnter)
      // .transition()
      // .attr('x', d => d.x)
      // .attr('y', d => d.y)
    titleTextUpdate.exit().remove()
  }

  filter (filterConfig: ChartScoutRouteLinesFilterConfig) {
    filterConfig = {
      stockMin: defaultStockMin,
      stockExceptZero: defaultStockExceptZero,
      sort: defaultSort,
      ...filterConfig
    }
    // if (!this.nodesData || !this.edgesData) {
    //   return
    // }
    this.filterConfig.stockMin = filterConfig.stockMin
    this.filterConfig.stockExceptZero = filterConfig.stockExceptZero
    this.filterConfig.sort = {
      ...filterConfig.sort
    }
    this.routes = Object.assign(this.routesOrigin)
    this.routes = this.filterRoutes(this.routes, this.filterConfig, this.dataset.mainRelatedToRoot)
    this.routes = this.updateRoutesDataPosition(this.routes, this.containerColumnCount)
  }

  setParams (params: ChartScoutRouteLinesParams) {
    this.params = {
      ...this.params,
      ...params
    }
    // targetId和原本不一樣才開始計算
    // if (this.data && config.targetId && this.targetId !== config.targetId) {
    //   // 回復預設 zoom
    //   this.transformZoom({
    //     x: 0,
    //     y: 0,
    //     k: 1
    //   })
    //   this.targetId = config.targetId
    //   this.routesOrigin = this.createRoutesData(this.sourceNodes, this.targetId)
      
    //   this.render()
    // }
    // if (config.transform != undefined) {
    //   this.transform = config.transform
    //   this.initZoom()
    // }
  }

  resize ({ width, height }: Size) {
    this.width = width
    this.height = height
    this.selection.attr('width', this.width)
    this.selection.attr('height', this.height)

    // 場景的欄數量改變的話重新計算資料位置
    const containerColumnCount = this.getContainerColumnCount(this.width)
    if (this.containerColumnCount !== containerColumnCount && this.routes.length) {
      this.containerColumnCount = containerColumnCount
      this.routes = this.updateRoutesDataPosition(this.routes!, this.containerColumnCount)
      this.render()
    }

    if (this.params && this.params.autoZoom) {
      this.transformZoom({
        x: 0,
        y: 0,
        k: 1
      })
    }
    
  }

  protected onZoom (eventTransform: { k:number; x:number; y:number }) {
    // 場景的欄數量改變的話重新計算資料位置
    const containerColumnCount = this.getContainerColumnCount(this.width)
    if (this.containerColumnCount !== containerColumnCount && this.routes.length) {
      this.containerColumnCount = containerColumnCount
      this.routes = this.updateRoutesDataPosition(this.routes!, this.containerColumnCount)
      this.render()
    }
  }

  // 計算場景的欄數量
  private getContainerColumnCount (width: number) {
    const k = this.transform.k // 顯示放大比率
    const paddingLeft = PADDING_LEFT * k
    const lineColumnWidth = LINE_COLUMN_WIDTH * k
    const containerColumnCount = Math.floor((width - (paddingLeft * 2)) / lineColumnWidth)
    if (containerColumnCount > 3) {
      return containerColumnCount
    } else {
      return 3 // 最少3欄
    }
  }
  
  private getContainerSize (): { width: number; height: number; x: number; y: number } {
    // 取得圖表container (div)的尺寸
    try {
      const node = this.selection.node()
      return node.getBoundingClientRect()
    } catch (e: any) {
      throw(e)
    }
  }

  // 依起始點計算路徑資料
  private createRoutesData (sourceNodes: Array<SourceNode>, targetId?: string): LineRoute[] {
    
    // 全部nodes資料
    const SourceNodesMap = new Map(sourceNodes.map(d => [d.uniID, d]))

    // 取得路徑起始nodes
    let startNodes: Array<SourceNode> = []
    if (targetId) {
      startNodes = sourceNodes.filter(d => d.uniID === targetId)
    } else {
      // 無指定起始id則為全部
      startNodes = Object.assign([], sourceNodes)
    }

    // 所有路徑
    const routes = startNodes
      .map(d => {
        let routesData: Array<RoutesDataUp> = []
        // 非根節點
        if (d['routes-in-id']) {
          // 將路徑資料一起重新排序
          routesData = this.parseRoutesDataUp(d)
        }
        return routesData
      })
      .flat() // 將多個 startNodes的資料攤平（有指定的話只會有一筆）
      .map((d, i) => {
        return {
          index: i,
          routesData: d,
          nodesData: [], // * 後面再計算
          edgesData: [], // * 後面再計算
          title: '', // * 後面再計算
          x: 0, // * 後面再計算
          y: 0 // * 後面再計算
        }
      })

    // 路徑上所有節點
    let nodeDataIndex = 0
    return routes.map((d, routeIndex) => {
      let nodeIndex = 0
      let nodesData: Array<LinesNodeDatum> = []
      let edgesData: Array<LinesEdgeDatum> = []
      // -- 先寫入第一筆 --
      const firstEdgeId = d.routesData['routes-in-id'][d.routesData['routes-in-id'].length - 1]
      const nodesArr = firstEdgeId.split('->')
      const rootNode = SourceNodesMap.get(nodesArr[1])
      nodesData.push(
        this.makeTreeNodes({
          node: rootNode!,
          routeIndex,
          nodeIndex, // 0
          index: nodeDataIndex
        })
      )
      nodeIndex ++
      nodeDataIndex ++
      // -- 迴圈取得所有edge的start-node --
      for (let i = d.routesData['routes-in-id'].length - 1; i >= 0; i--) {
        const edgeId = d.routesData['routes-in-id'][i]
        const edgeValue = d.routesData['routes-of-stock-detail'][i]
        const nodesArr = edgeId.split('->')
        const startNodeId = nodesArr[0]
        const endNodeId = nodesArr[1]
        const startNode = SourceNodesMap.get(startNodeId)
        nodesData.push(
          this.makeTreeNodes({
            node: startNode!,
            routeIndex,
            nodeIndex: nodeIndex,
            index: nodeDataIndex
          })
        )
        edgesData.push(
          this.makeTreeEdges({
            edgeId,
            edgeValue,
            routeIndex,
            startNodeId,
            endNodeId,
            // startNodeIndex: nodeDataIndex,
            // endNodeIndex: nodeDataIndex - 1
            startNodeIndex: nodeIndex,
            endNodeIndex: nodeIndex - 1
          })
        )
        nodeIndex ++
        nodeDataIndex ++
      }
      return {
        ...d,
        nodesData,
        edgesData,
        title: this.params.titleContent!(d, routeIndex)
      }
    })
  }

  // 依起始點計算路徑資料
  private createRoutesDownData (sourceNodes: Array<SourceNode>, targetId?: string): LineRoute[] {
    
    // 全部nodes資料
    const SourceNodesMap = new Map(sourceNodes.map(d => [d.uniID, d]))

    // 取得路徑起始nodes
    let startNodes: Array<SourceNode> = []
    if (targetId) {
      startNodes = sourceNodes.filter(d => d.uniID === targetId)
    } else {
      // 無指定起始id則為全部
      startNodes = Object.assign([], sourceNodes)
    }

    // 所有路徑
    const routes = startNodes
      .map(d => {
        let routesData: Array<RoutesDataDown> = []
        // 非根節點
        if (d['routes_to_downs-in-id']) {
          // 將路徑資料一起重新排序
          routesData = this.parseRoutesDataDown(d)
        }
        return routesData
      })
      .flat() // 將多個 startNodes的資料攤平（有指定的話只會有一筆）
      .map((d, i) => {
        return {
          index: i,
          routesData: d,
          nodesData: [], // * 後面再計算
          edgesData: [], // * 後面再計算
          title: '', // * 後面再計算
          x: 0, // * 後面再計算
          y: 0 // * 後面再計算
        }
      })

    // 路徑上所有節點
    let nodeDataIndex = 0
    return routes.map((d, routeIndex) => {
      let nodeIndex = 0
      let nodesData: Array<LinesNodeDatum> = []
      let edgesData: Array<LinesEdgeDatum> = []
      // -- 先寫入第一筆 --
      const firstEdgeId = d.routesData['routes_to_downs-in-id'][d.routesData['routes_to_downs-in-id'].length - 1]
      const nodesArr = firstEdgeId.split('->')
      const rootNode = SourceNodesMap.get(nodesArr[1])
      nodesData.push(
        this.makeTreeNodes({
          node: rootNode!,
          routeIndex,
          nodeIndex, // 0
          index: nodeDataIndex
        })
      )
      nodeIndex ++
      nodeDataIndex ++
      // -- 迴圈取得所有edge的start-node --
      for (let i = d.routesData['routes_to_downs-in-id'].length - 1; i >= 0; i--) {
        const edgeId = d.routesData['routes_to_downs-in-id'][i]
        const edgeValue = d.routesData['routes_to_downs-of-stock-detail'][i]
        const nodesArr = edgeId.split('->')
        const startNodeId = nodesArr[0]
        const endNodeId = nodesArr[1]
        const startNode = SourceNodesMap.get(startNodeId)
        nodesData.push(
          this.makeTreeNodes({
            node: startNode!,
            routeIndex,
            nodeIndex: nodeIndex,
            index: nodeDataIndex
          })
        )
        edgesData.push(
          this.makeTreeEdges({
            edgeId,
            edgeValue,
            routeIndex,
            startNodeId,
            endNodeId,
            // startNodeIndex: nodeDataIndex,
            // endNodeIndex: nodeDataIndex - 1
            startNodeIndex: nodeIndex,
            endNodeIndex: nodeIndex - 1
          })
        )
        nodeIndex ++
        nodeDataIndex ++
      }
      return {
        ...d,
        nodesData,
        edgesData,
        title: this.params.titleContent!(d, routeIndex)
      }
    })
  }

  private makeTreeNodes ({ node, routeIndex, nodeIndex, index }: {
    node: SourceNode;
    routeIndex: number;
    nodeIndex: number;
    index: number
  }): LinesNodeDatum {
    const { textWidth, labels } = this.getLabelInfo(node.name)
    let nodeType = ''
    let width = NODE_WIDTH_DEFAULT
    const height = NODE_HEIGHT_MIN + (labels.length - 1) * NODE_TEXT_SIZE
    // 非根節點
    if (node['routes-in-id'] || node['routes_to_downs-in-id']) {
      nodeType = node.role
      // 自然人的node寬度是依文字調整
      if (nodeType === '自然人') {
        width = textWidth + (NODE_TEXT_LEFT * 2)
      }
    }
    // 根節點
    else {
      nodeType = 'root'
    }
  
    let tags: string[] = []
    if (node.public_issue === '上市') {
      tags.push('市')
    } else if (node.public_issue === '上櫃') {
      tags.push('櫃')
    }
    if (node.role === '自然人' && node['total-investment-ratio'] && node['total-investment-ratio'] >= 25) {
      tags.push('益')
    }
  
    return <LinesNodeDatum>{
      index,
      id: `${routeIndex}_${node.uniID}`,
      uniID: node.uniID,
      label: node.name,
      labels,
      nodeType,
      x: -1, // * 後面程式處理
      y: -1, // * 後面程式處理
      width,
      height,
      hasTop: false,
      isTopExpanded: false,
      tags,
      sourceData: node, // 原始資料
      _sourceId: node.uniID,
      _routeIndex: routeIndex,
      _nodeIndex: nodeIndex
    }
  }
  
  private makeTreeEdges ({ edgeId, edgeValue, routeIndex, startNodeId, endNodeId, startNodeIndex, endNodeIndex }: {
    edgeId: string;
    edgeValue: number;
    routeIndex: number;
    startNodeId: string;
    endNodeId: string;
    startNodeIndex: number;
    endNodeIndex: number
  }): LinesEdgeDatum {
    return {
      id: `${routeIndex}_${edgeId}`,
      startNodeId,
      endNodeId,
      startX: 0, // * 後面程式處理
      startY: 0, // * 後面程式處理
      endX: 0, // * 後面程式處理
      endY: 0, // * 後面程式處理
      startCount: 0, // 無
      startCountX: -1,
      startCountY: -1,
      endCount: 0, // 無
      endCountX: -1,
      endCountY: -1,
      label: this.formatPercentage(edgeValue),
      labelX: 0, // * 後面程式處理
      labelY: 0, // * 後面程式處理
      labelTransformX: 0,
      labelTransformY: 0,
      labelDotShow: false, // 不顯示圓點
      labelTextAnchor: 'start', // * 後面程式處理
      labelDominantBaseline: 'auto',
      pathD: '', // * 後面程式處理
      value: edgeValue,
      _sourceId: edgeId, // ${startNodeId}->${endNodeId}
      _routeIndex: routeIndex,
      _startNodeIndex: startNodeIndex,
      _endNodeIndex: endNodeIndex
    }
  }

  private filterRoutes (
    routes: Array<LineRoute>,
    { stockMin = defaultStockMin, stockExceptZero = defaultStockExceptZero, sort = defaultSort}: ChartScoutRouteLinesFilterConfig,
    mainRelatedToRoot: 'root' | 'up' | 'down' | 'neibor'
  ): Array<LineRoute> {
    // let edgeFilter = (edge: LinesEdgeDatum) => edge.value >= defaultStockMin
    // if (stockMin > 0) {
    //   edgeFilter = (edge: LinesEdgeDatum) => edge.value >= stockMin
    // } else if (stockExceptZero == true) {
    //   edgeFilter = (edge: LinesEdgeDatum) => edge.value > 0
    // }
    const routesDataKey = mainRelatedToRoot === 'up' ? 'routes-of-stock-detail-single-value' : 'routes_to_downs-of-stock-detail-single-value'
    
    routes = routes
      .filter(route => {
        const predicate = this.makeFilterPredicate(stockMin, stockExceptZero)
        return predicate((route.routesData as any)[routesDataKey])
      })
      .sort((a, b) => {
        if ((a.routesData as any)[routesDataKey] - (b.routesData as any)[routesDataKey] > 0) {
          return (sort as any)[routesDataKey]!
        } else {
          return - (sort as any)[routesDataKey]!
        }
      })
      .map((d, i) => {
        return {
          ...d,
          title: this.params.titleContent!(d, i)
        }
      })
    return routes
  }

  // 計算位置
  private updateRoutesDataPosition (routes: Array<LineRoute>, containerColumnCount: number) {
    let lineStartY = PADDING_TOP // line的初始y
    // let currentLineNo = 0
    routes.forEach((route, routeIndex) => {
      // 計算 nodesData
      route.nodesData.forEach((node, index) => {
        // 如換routeIndex則初始高度往下移一格
        // if (node._routeIndex != currentLineNo && route.nodesData[index - 1]) {
        //   lineStartY = route.nodesData[index - 1].y + LINE_ROW_HEIGHT // 上一筆資料的y往上移一格
        //   currentLineNo = node._routeIndex
        // }
        if (index === 0 && routeIndex >= 1) {
          // 前一個route的最後一個node的高度往下加
          lineStartY = routes[routeIndex - 1].nodesData[routes[routeIndex - 1].nodesData.length - 1].y + LINE_ROW_HEIGHT // 上一筆資料的y往上移一格
        }
        // 計算line內的欄/列
        let columnIndex = 0
        let rowIndex = 0
        if (node._nodeIndex < containerColumnCount) {
          columnIndex = node._nodeIndex
        } else {
          // 第二列之後的欄的起始為1，所以要先扣掉第一列的欄位數量，第二列之後用 containerColumnCount - 1 做計算
          columnIndex = ((node._nodeIndex - containerColumnCount) % (containerColumnCount - 1)) + 1
          rowIndex = Math.floor((node._nodeIndex - containerColumnCount) / (containerColumnCount - 1)) + 1
        }
        // 寫入座標
        route.nodesData[index].x = PADDING_LEFT + (LINE_COLUMN_WIDTH * columnIndex)
        route.nodesData[index].y = lineStartY + LINE_TITLE_HEIGHT + (LINE_ROW_HEIGHT * rowIndex)
      })
      // route座標
      route.x = route.nodesData[0].x
      route.y = lineStartY
      // 計算 edgesData
      route.edgesData.forEach((edge, index) => {
        const startNode = route.nodesData[edge._startNodeIndex]
        const endNode = route.nodesData[edge._endNodeIndex]
        // case 起點和終點是水平的
        if (startNode.y === endNode.y) {
          route.edgesData[index].startX = startNode.x
          route.edgesData[index].startY = startNode.y
          route.edgesData[index].endX = endNode.x + endNode.width
          route.edgesData[index].endY = endNode.y
          route.edgesData[index].labelX = (route.edgesData[index].startX + route.edgesData[index].endX) / 2
          route.edgesData[index].labelY = startNode.y - 10
          route.edgesData[index].labelTextAnchor = 'middle'
          route.edgesData[index].pathD = `M${route.edgesData[index].startX} ${route.edgesData[index].startY}`
          route.edgesData[index].pathD += ` H${route.edgesData[index].endX}`
        }
        // case 跨行
        else {
          route.edgesData[index].startX = startNode.x + (startNode.width / 2)
          route.edgesData[index].startY = startNode.y - (startNode.height / 2)
          route.edgesData[index].endX = endNode.x + (endNode.width / 2)
          route.edgesData[index].endY = endNode.y + (endNode.height / 2)
          route.edgesData[index].labelX = route.edgesData[index].startX
          const centerY = (route.edgesData[index].startY + route.edgesData[index].endY) / 2
          route.edgesData[index].labelY = centerY + EDGE_CURVE
          route.edgesData[index].labelTextAnchor = 'start'
          route.edgesData[index].pathD = `M${route.edgesData[index].startX} ${route.edgesData[index].startY}`
          route.edgesData[index].pathD += ` V${route.edgesData[index].labelY}` // 垂直線
          route.edgesData[index].pathD += ` Q${route.edgesData[index].startX} ${centerY}, ${route.edgesData[index].startX + EDGE_CURVE} ${centerY}` // 弧線
          route.edgesData[index].pathD += ` H${route.edgesData[index].endX - EDGE_CURVE}` // 橫直線
          route.edgesData[index].pathD += ` Q${route.edgesData[index].endX} ${centerY}, ${route.edgesData[index].endX} ${centerY - EDGE_CURVE}` // 弧線
          route.edgesData[index].pathD += ` V${route.edgesData[index].endY}`
        }
        
      })
    })

    return routes
  }

}